import { EBillingStatus, IBillingStatusState } from '../../types/reducers/billingStatus';

const DEFAULT_STATE = { status: EBillingStatus.Ok };

export function billingStatusReducer(state: IBillingStatusState) {
  return state || DEFAULT_STATE;
}
